import './create-maturity-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column } from 'react-display-flex'

import { httpClient } from '../../../../../util/http-client'
import { maturityCompliancesRulesMessages } from '../messages'
import { createMaturityComplianceRuleValues } from './models'
import { issuerMaturityRuleValidationSchema } from './validators'

interface CreateMaturityComplianceProps {
  groupId: number
  domain: string
  onSuccess?: () => void
}

export const CreateMaturityCompliance = ({ groupId, domain, onSuccess }: CreateMaturityComplianceProps) => {
  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/maturities/groups/${groupId}/rules`, {
        method: 'POST',
        domain,
        data: formData,
      })
      notification.success({
        message: maturityCompliancesRulesMessages.common.success,
        description: maturityCompliancesRulesMessages.create.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: maturityCompliancesRulesMessages.common.error,
        description: error.error_message || maturityCompliancesRulesMessages.create.error,
      })
    }
  }

  return (
    <Formik
      initialValues={createMaturityComplianceRuleValues}
      validationSchema={issuerMaturityRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="create-maturity-compliance-rule">
        <FormItem name="displayTextKey" label="Label" required>
          <Input name="displayTextKey" />
        </FormItem>
        <FormItem name="maturityDaysFrom" label="Maturity days from" required>
          <InputNumber name="maturityDaysFrom" min={0} />
        </FormItem>
        <FormItem name="maturityDaysTo" label="Maturity days to" required>
          <InputNumber name="maturityDaysTo" min={0} />
        </FormItem>
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" min={0} />
        </FormItem>
        <FormItem name="minLimit" label="Min Limit" required>
          <InputNumber name="minLimit" min={0} />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
